export const environment = {
    production: false,
    bankCardApiUrl:  'http://localhost:5000/api/',
    idealTimeOutError: 1800000 //30*60*1000
}